import React, { useState, useEffect } from 'react';
import { HelpCircle, BookOpen } from 'lucide-react';
import LessonQuiz from './LessonQuiz';
import { exercisesApi } from '../services/api';

interface QuizButtonProps {
  lessonId: string;
  lessonTitle?: string;
  isIndependentQuiz?: boolean;
}

const QuizButton: React.FC<QuizButtonProps> = ({ lessonId, isIndependentQuiz = false }) => {
  const [showQuiz, setShowQuiz] = useState(false);
  const [hasQuestions, setHasQuestions] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkForQuestions = async () => {
      try {
        setLoading(true);
        const response = await exercisesApi.getLessonQuestions(lessonId);
        setHasQuestions(response.data.hasQuestions || false);
      } catch (error) {
        console.error('Error checking for questions:', error);
        setHasQuestions(false);
      } finally {
        setLoading(false);
      }
    };

    if (lessonId) {
      checkForQuestions();
    }
  }, [lessonId]);

  const handleOpenQuiz = () => {
    setShowQuiz(true);
  };

  const handleCloseQuiz = () => {
    console.log('🟡 handleCloseQuiz llamado');
    setShowQuiz(false);
  };

  if (loading) {
    return (
      <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
          <span className="ml-2 text-gray-600 text-sm">Verificando quiz...</span>
        </div>
      </div>
    );
  }

  if (!hasQuestions) {
    return null;
  }

  return (
    <>
      {/* Botón Quiz Opcional */}
      <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="bg-blue-100 p-2 rounded-full">
              <HelpCircle className="w-5 h-5 text-blue-600" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-gray-800">
                Quiz Opcional Disponible
              </h3>
              <p className="text-xs text-gray-600">
                Practica lo que has aprendido con algunas preguntas
              </p>
            </div>
          </div>
          <button
            onClick={handleOpenQuiz}
            className="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
          >
            <BookOpen className="w-4 h-4 mr-1" />
            Tomar Quiz
          </button>
        </div>
      </div>

      {/* Modal del Quiz */}
      {showQuiz && (
        <LessonQuiz
          lessonId={lessonId}
          onClose={handleCloseQuiz}
          isIndependentQuiz={isIndependentQuiz}
        />
      )}
    </>
  );
};

export default QuizButton;